// @ts-nocheck

import { last } from 'lodash';

import { CashoutActionTypes } from '../../types/actions/cashout';
import isHistoryItemDetail from '../../utils/routes/isHistoryItemDetail';

export const handledActionTypes = [CashoutActionTypes.CASHOUT_PARTIAL, CashoutActionTypes.CASHOUT_SUCCESS];

let requests = [];

/**
 * A bet XXXX-XXXX will be split into 2 bets with a partial cashout
 * -> XXXX-XXXX-1 and XXXX-XXXX-2
 * This middleware watch a partial cashout on historyItemDetail view
 * to redirect user on the new created bet with the betslipReference as
 * XXXX-XXXX-(X+2)
 */

const historyItemDetailCashoutMiddlewareHandler = ({ action, params: { history } }: HandlerProps) => {
  if (handledActionTypes.indexOf(action.type) !== -1) {
    const pathname = history.location.pathname;

    if (action.type === CashoutActionTypes.CASHOUT_PARTIAL && isHistoryItemDetail(pathname)) {
      requests.push(action.payload.id);
    }

    if (action.type === CashoutActionTypes.CASHOUT_SUCCESS && isHistoryItemDetail(pathname)) {
      if (requests.indexOf(action.payload.id) !== -1) {
        const ref = last(pathname.split('/'));
        const parts = ref.split('-');
        let newSuffix = 2;
        let redirection = pathname;

        if (parts.length === 3) {
          // if already a cashout bet XXXX-XXXX-suffix
          const currentSuffix = parseInt(last(parts).split('/'), 10);
          newSuffix = currentSuffix + 2;
          redirection = pathname.slice(0, pathname.lastIndexOf('-'));
        }
        requests = requests.filter((id) => id !== action.payload.id);
        history.push(`${redirection}-${newSuffix}`);
      }
    }
  }
};

export default historyItemDetailCashoutMiddlewareHandler;
